import { combineReducers } from "redux";

import { loginReducer } from "./modules/login";
import { userReducer } from "./modules/user";
import { diaryReducer } from "./modules/diary";
import { managerReducer } from "./modules/manager";
import { dashboardReducer } from "./modules/dashboard";
import menuReducer from "./modules/menu/reducer";

const appReducer = combineReducers({
  login: loginReducer,
  user: userReducer,
  menu: menuReducer,
  diary: diaryReducer,
  manager: managerReducer,
  dashboard: dashboardReducer,
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers.js